import { User } from './user';

export class Enterprise {
	public id: number;
	public name: string;
	public createdAt: Date;
	public updatedAt: Date;

	public logins: User[];

	constructor(enterprise?: Subset<Enterprise>) {
		Object.assign(this, enterprise);

		this.logins = this.logins ? this.logins.map(u => new User(u)) : this.logins;
	}
}
